module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/notosanskr/notokr-light.woff
// module id = Bed7
// module chunks = 0